import { render, staticRenderFns } from "./IconFileWord.vue?vue&type=template&id=5515c257&"
import script from "./IconFileWord.vue?vue&type=script&lang=ts&"
export * from "./IconFileWord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports